//mqtt全局变量在index.html中使用CDN导入
import {formatDateTime} from "./utility/util"
const mqtt = require('mqtt');

// 连接选项
const options = {
    // 超时时间
    connectTimeout: 4000,

    // 认证信息
    clientId: 'codeUpdateManagement_' + makeId() + ` ${formatDateTime(new Date())}`,
    username: 'hshq',
    password: 'hshq',

    // 心跳时间
    keepalive: 60,
    clean: true,
};

const topicOptions = {
    qos: 1
};

// WebSocket 连接字符串
let host = 'www.wtxwlw.com';
// const WebSocket_URL = `ws://${host}:8083/mqtt`;
const WebSocket_URL = `wss://${host}/mqtt`;

let client = null;
let updateInfo = null;
let updateResult = null;
let topic = '';

start();

function start() {
    client = mqtt.connect(WebSocket_URL, options);
    client.on('connect', () => {
        window.console.log('连接mqtt服务器成功');
    });

    client.on('reconnect', (error) => {
        window.console.log('正在重新连接到mqtt服务器', error);
    });

    client.on('error', (error) => {
        window.console.log('连接mqtt服务器失败:', error);
    });

    //处理消息
    client.on('message', function (topic, message) {
        // message is Buffer
        let levels = topic.split('/');
        if (levels.length < 3) return;

        let log = '主题:'+topic+'; 消息:'+message.toString();
        window.console.log('INFO', `接收到消息\n${log}`);

        if (levels[0] === 'codeUpdateManagement') {           //处理升级日志信息
            let log = formatDateTime(new Date()) + ' 消息：' + message.toString() + '\n';
            updateResult.logString = log + updateResult.logString;
            // processMessage(levels, message);
        }
    });
}

function init(updateInfoRef, updateResultRef) {
    updateInfo = updateInfoRef;
    updateResult = updateResultRef;
    subscribeMessage();
}

//处理消息
/*function processMessage(levels, message) {
    //保存上报信息
}*/

//mqtt客户端订阅消息
function subscribeMessage() {
    //取消旧的订阅
    if (topic) {
        client.unsubscribe(topic, error => {
            if (!error) {
                window.console.log('INFO', '取消主题'+'"'+topic+'"'+'成功');
            }
        });
    }

    if (parseInt(updateInfo.startDeviceId) === parseInt(updateInfo.endDeviceId) ) {
        //主题codeUpdateManagement/projectId/codeId/deviceId，接收单台设备升级日志
        topic = `codeUpdateManagement/${updateInfo.projectId}/${updateInfo.codeId}/${updateInfo.startDeviceId}`;
    } else {
        //主题code-ws/projectId/codeId/#，接收多台设备升级日志
        topic = `codeUpdateManagement/${updateInfo.projectId}/${updateInfo.codeId}/#`;
    }
    client.subscribe(topic, topicOptions, function (error) {
        if (!error) {
            window.console.log('INFO', '订阅主题'+'"'+topic+'"'+'成功');
        }
    });
}

//发送消息
function publishMessage(topic, contentString) {
    client.publish(topic, contentString, topicOptions);
    window.console.log(`发送消息主题为:${topic}`);
    window.console.log(`发送消息内容为:${contentString}`);
}

function makeId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

export default {
    publishMessage,
    init
}
